import { useEffect, useRef, useState } from 'react';

const POLL_INTERVAL_MS = 5 * 60 * 1000;
const CURRENT_VERSION = __APP_VERSION__;

export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    async function check() {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data: { version: string } = await res.json();
        if (data.version && data.version !== CURRENT_VERSION) {
          setUpdateAvailable(true);
        }
      } catch {
        // Network error — ignore silently
      }
    }

    check();
    timerRef.current = setInterval(check, POLL_INTERVAL_MS);
    window.addEventListener('focus', check);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      window.removeEventListener('focus', check);
    };
  }, []); // CURRENT_VERSION is a module-level constant; setUpdateAvailable is stable

  return { updateAvailable };
};
